import React from 'react';
import ContentWelcomeWA from '../components/pages/self-provision-WA/welcomeWaitingArea/content';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';

const WASelfProvisionExistingUser = (props) => {
  return (
    <div>
      <ContentWelcomeWA
        showWaitingAreaWelcomeModal={props.showWaitingAreaWelcomeModal}
        waitingArea={props.waitingArea}
        dispatch={props.dispatch}
      />
    </div>
  );
};
function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;

  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);

  return {
    waitingArea: waitingArea,
    showWaitingAreaWelcomeModal: state.modalReducer.showWaitingAreaWelcomeModal || false,
  };
}

export default connect(mapStateToProps, null)(WASelfProvisionExistingUser);
